<template>
  <div>
    <ul class="manual-main-right-list">
      <li class="manual-main-right-item" v-for="item in exerciseList" :key="item.id">
        <!-- 题干部分 -->
        <div class="manual-question" :id="`question_${item.id}`" @click="showAnalyize(item)" :class="!item.isShowMore ? 'fixHeightAuto' : ''">
          <div class="manual-question-title" v-html="item.title"></div>
          <div class="manual-question-options" v-if="item.options && item.options.length > 0">
            <div v-for="(opt, order) in item.options" :key="order">
              <div
                v-for="(value, key) in opt"
                :key="key"
                :style="{
                  width: item.w_arr ? item.w_arr[order].width + 'px' : '',
                  paddingLeft: item.type_id == 7 && item.w_arr && item.w_arr[order].row == 2 && key == 'C' ? '60px' : '',
                }"
              >
                <span v-if="item.type_id == 7 && key == 'A'">({{ order + 1 }})</span>
                <span
                  :class="item.type_id == 7 && key == 'A' ? 'spacer' : ''"
                  :style="{ left: item.type_id == 7 && item.w_arr && item.w_arr[order].row == 2 && key == 'C' ? '40px' : '' }"
                  >{{ key }}.</span
                >
                <span v-html="value"></span>
              </div>
            </div>
          </div>
          <div class="audio-wrap" v-if="item.file">
            <audio controls>
              <source :src="item.file" />
            </audio>
          </div>
          <ol class="manual-subquestion" v-if="item.sub_questions && item.sub_questions.length > 0">
            <li v-for="(subQuestion, index) in item.sub_questions" :key="subQuestion.id">
              <span>({{ subQuestion.question_sort }})</span>
              <div class="manual-subquestion-title" v-html="subQuestion.title"></div>
              <!-- 子题选项 -->
              <div class="manual-subquestion-options" v-for="subOption in subQuestion.options" :key="subOption.index">
                <div v-for="(value, key) in subOption" :key="key" :style="{ width: subQuestion.sub_width && subQuestion.sub_width.width + 'px' }">
                  <span>{{ key }}.</span>
                  <span v-html="value"></span>
                </div>
              </div>
              <div class="manual-subquestion-answer" v-if="item.exerciseAnlysie" v-show="item.isShow">
                <span class="manual-subquestion-answer-left">【答案】</span>
                <template v-if="item.exerciseAnlysie.type == 'image'">
                  <p class="manual-subquestion-answer-right">
                    <img :src="item.exerciseAnlysie.answerImg[index]" />
                  </p>
                </template>
                <template v-else>
                  <p
                    class="manual-subquestion-answer-right"
                    v-html="item.exerciseAnlysie.answer[index] ? item.exerciseAnlysie.answer[index] : '暂无内容'"
                  ></p>
                </template>
              </div>
            </li>
          </ol>
        </div>
        <!-- 分析部分 -->
        <div v-show="item.isShow" class="manual-analyize-wrap">
          <template v-if="item.exerciseAnlysie">
            <div class="manual-analyize">
              <div class="manual-analyize-item" v-if="item.sub_questions.length == 0">
                <span class="manual-analyize-left">【答案】</span>
                <template v-if="item.exerciseAnlysie.type == 'image'">
                  <div class="manual-analyize-right">
                    <img :src="item.exerciseAnlysie.answerImg" />
                  </div>
                </template>
                <template v-else>
                  <div class="manual-analyize-right" v-html="item.exerciseAnlysie.answer[0] ? item.exerciseAnlysie.answer[0] : '暂无内容'"></div>
                </template>
              </div>
              <div class="manual-analyize-item">
                <span class="manual-analyize-left">【考点】</span>
                <div class="manual-analyize-right" v-html="item.exerciseAnlysie.centre ? item.exerciseAnlysie.centre : '暂无内容'"></div>
              </div>
              <div class="manual-analyize-item">
                <span class="manual-analyize-left">【解析】</span>
                <div v-if="item.exerciseAnlysie.status == 0">
                  <template v-if="item.exerciseAnlysie.type == 'image'">
                    <div class="manual-analyize-right">
                      <img :src="item.exerciseAnlysie.analysisImg" />
                    </div>
                  </template>
                  <template v-else>
                    <div class="manual-analyize-right" v-html="item.exerciseAnlysie.analysis ? item.exerciseAnlysie.analysis : '暂无内容'"></div>
                  </template>
                </div>
                <div class="manual-no-analyize" v-else>
                  <p>
                    <i class="iconfont icon-tixing2"></i>
                    <span v-html="item.exerciseAnlysie.analysis"></span>
                  </p>
                </div>
              </div>
            </div>
          </template>
          <!-- 未登录 -->
          <div class="manual-analyize-noLogin" v-else>
            <span
              ><i class="iconfont icon-tixing2"></i>未登录用户无法查看答案与解析！<a href="javascript:void(0);" @click="jumpToLogin"
                >立即登录</a
              ></span
            >
          </div>
        </div>
        <!-- 操作部分 -->
        <div class="manual-message">
          <div class="manual-message-layer" v-if="!item.isShow && item.isShowMore">
            <span @click="showMoreQueston(item)">查看全部<i class="iconfont icon-xiangxiashuangjiantou"></i></span>
          </div>
          <div class="manual-message-attr">
            <span class="manual-message-span1">{{ item.type_name }}</span>
            <em>|</em> <span>{{ item.class_name }}</span> <em>|</em> <span>{{ item.difficult }}</span> <em>|</em>
            <span
              >组卷<em> {{ item.used_num }} </em>次</span
            >
            <em v-if="item.source">|</em>
            <span v-if="item.source" class="source"
              ><span>来源：</span
              ><a :href="item.source_link" :title="item.source" target="_blank" class="manual-message-span2">{{ item.source }}</a></span
            >
          </div>
          <div class="manual-message-handle">
            <a href="javascript:;" @click="downloadQuestion(item.question_link)"><i class="iconfont icon-plus-download"></i>下载</a>
            <a :href="item.question_link" target="_blank"><i class="iconfont icon-xiangqing"></i>查看解析</a>
            <a href="javascript:;" @click="toggleCollect(item)"
              ><i class="iconfont" :class="item.collect == 1 ? 'icon-shoucang0' : 'icon-favourite'"></i>收藏</a
            >
            <a href="javascript:;" class="manual-message-btn manual-message-add" v-if="item.in_basket == 0" @click="AddExercise(item.id)"
              ><i class="iconfont icon-tianjia"></i>试题篮</a
            >
            <a href="javascript:;" class="manual-message-btn manual-message-remove" v-else @click="removeExercise(item.id)"
              ><i class="iconfont icon-jian"></i>试题篮</a
            >
          </div>
        </div>
      </li>
    </ul>
    <!-- 提示购物车数量超量弹窗 -->
    <el-dialog
      :visible="overNumberFlag"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="400px"
      :lock-scroll="true"
      center
      class="shopping-cart-overNum-dialog"
      @close="overNumberFlag = false"
    >
      <div class="dialog-body">
        <img src="../assets/images/tixing.png" alt="" />
        <h5>当前试题篮仅允许加{{ total }}题</h5>
        <p>开通组卷VIP，试题篮数量不受限，300万精选试题解析任意看，还享7折组卷优惠，10大VIP特权</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="realizeVIP">了解组卷VIP</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
var that
import { mapGetters } from 'vuex'
import * as util from '../utils/util.js'
import { questionCollect, addPaperBaskets, removePaperExercise, paperAnswer } from '@/api/manual'
export default {
  name: 'question',
  data() {
    return {
      stage_id: '',
      subject_id: '',
      exerciseList: [], // 后台返回当前页十条的试题数据
      overNumberFlag: false, // 试题超过60提示弹窗
      cartPaper_id: '', // 试题篮paperid
      total: '',
    }
  },
  props: ['questionList', 'stageId', 'subjectId', 'basketPaperId', 'basketTotal'],
  computed: {
    ...mapGetters(['baseLink', 'userInfo']),
  },
  watch: {
    questionList: {
      handler(newval, old) {
        let that = this
        that.exerciseList = that.questionList
      },
      deep: true,
      immediate: true,
    },
    stageId() {
      that.stage_id = that.stageId
    },
    subjectId() {
      that.subject_id = that.subjectId
    },
    basketTotal() {
      that.total = that.basketTotal
    },
    basketPaperId() {
      that.cartPaper_id = that.basketPaperId
    },
  },
  created() {
    that = this
  },
  mounted() {
    that.stage_id = that.stageId
    that.subject_id = that.subjectId
    that.total = that.basketTotal
    that.cartPaper_id = that.basketPaperId
    that.exerciseList = that.questionList
  },
  methods: {
    setBtnStatus(id) {
      // 点击加入移除试题篮改变当前试题状态
      that.exerciseList.forEach(item => {
        if (item.id == id) {
          if (item.in_basket == 1) {
            item.in_basket = 0
          } else {
            item.in_basket = 1
          }
        }
      })
    },
    AddExercise(id) {
      // 加入试卷
      that.addExerciseToBaskets(id) // 添加试题
    },
    toggleCollect(item) {
      // 收藏、取消收藏
      let data = {
        id: item.id,
      }
      return new Promise((resolve, reject) => {
        questionCollect(data)
          .then(res => {
            if (res.code == 200) {
              if (item.collect == 0) {
                util.showTips('收藏成功')
                that.$set(item, 'collect', 1)
              } else {
                util.showTips('取消收藏')
                that.$set(item, 'collect', 0)
              }
            }
          })
          .catch(err => {
            util.locatioanToLogin(err)
          })
      })
    },
    addExerciseToBaskets(id) {
      // 添加试题到试题篮
      let data = {
        stage_id: that.stage_id,
        subject_id: that.subject_id,
        question_id: id,
      }
      return new Promise((resolve, reject) => {
        addPaperBaskets(data)
          .then(res => {
            if (res.code === 200) {
              util.showTips('加入成功')
              that.$emit('refreshCartList', true) // 重新获取试题篮列表
              that.setBtnStatus(id) // 改变按钮状态
            } else if (res.code == 400) {
              if (this.total <= 200) {
                this.total = res.data.allow_count
                this.overNumberFlag = true
              } else {
                util.showTips('系统繁忙（#200），请稍后再试！')
              }
            }
          })
          .catch(err => {
            if (err.code === 200) {
              util.showTips('加入成功')
              that.$emit('refreshCartList', true) // 重新获取试题篮列表
              that.setBtnStatus(id) // 改变按钮状态
            } else if (err.code == 400) {
              if (this.total <= 200) {
                this.total = err.data.allow_count
                this.overNumberFlag = true
              } else {
                util.showTips('系统繁忙（#200），请稍后再试！')
              }
            }
            util.locatioanToLogin(err)
          })
      })
    },
    removeExercise(id) {
      // 移除试题篮
      let data = {
        type: 3,
        paper_id: that.cartPaper_id,
        question_id: id,
      }
      return new Promise((resolve, reject) => {
        removePaperExercise(data)
          .then(res => {
            if (res.code === 200) {
              util.showTips('移除成功')
              that.setBtnStatus(id)
              that.$emit('refreshCartList', true)
            }
          })
          .catch(err => {
            util.locatioanToLogin(err)
          })
      })
    },
    showAnalyize(item) {
      // 显示解析
      if (!item.isShow) {
        let data = {
          question_id: item.id,
        }
        return new Promise((resolve, reject) => {
          paperAnswer(data)
            .then(res => {
              if (res.code === 200) {
                that.$set(item, 'isShow', !item.isShow)
                that.$set(item, 'exerciseAnlysie', res.data)
                if (item.isMore) {
                  that.$set(item, 'isShowMore', false)
                }
              }
            })
            .catch(err => {
              if (err.code == 401) {
                that.$set(item, 'exerciseAnlysie', '')
                that.$set(item, 'isShow', !item.isShow)
                that.$set(item, 'isShowMore', false)
              } else {
                util.showTips(err.status)
              }
            })
        })
      } else {
        that.$set(item, 'isShow', !item.isShow)
      }
    },
    jumpToLogin() {
      let url = encodeURIComponent(window.location.href)
      window.location.href = `${that.baseLink}login?redirect=${url}`
    },
    showMoreQueston(item) {
      // 查看隐藏部分题目
      if (item.isMore) {
        that.$set(item, 'isShowMore', false)
      }
    },
    downloadQuestion(url) {
      window.open(url, '_blank')
      // if (!that.userInfo) {
      //   window.open(`${that.baseLink}login?redirect=${encodeURIComponent(url)}`, '_blank')
      // } else {
      //   window.open(url, '_blank')
      // }
    },
    realizeVIP() {
      this.overNumberFlag = false
      window.open(`${this.baseLink}vip`)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.manual-main-right-list {
  background-color: #f2f2f2;
  padding-bottom: 1px;
  .manual-main-right-item {
    margin-bottom: 10px;
    background-color: #fff;
    overflow: hidden;
    .manual-question {
      overflow: hidden;
      box-sizing: border-box;
      padding: 20px 20px 0 20px;
      text-align: left !important;
      cursor: pointer;
      max-height: 300px;
      min-height: 70px;
      &.fixHeightAuto {
        max-height: none;
      }
      .manual-question-title {
        margin-bottom: 10px;
        line-height: 32px;
        color: #666;
        font-size: 14px;
        overflow: inherit;
        & > p {
          color: #333;
          margin: 0 !important;
        }
      }
      .audio-wrap {
        margin-bottom: 10px;
        audio {
          outline: none;
        }
      }
      .manual-question-options {
        margin-bottom: 10px;
        & > div {
          padding-bottom: 5px;
          overflow: hidden;
          & > div {
            // width: 100%;
            color: #666;
            font-size: 14px;
            line-height: 26px;
            display: inline-block;
            box-sizing: border-box;
            position: relative;
            vertical-align: top;
            padding: 0 20px;
            table {
              td {
                width: auot !important;
              }
            }
            span {
              display: inline-block;
              &:nth-child(1) {
                position: absolute;
                top: 0;
                left: 0;
              }
              &.spacer + span {
                vertical-align: middle;
                white-space: nowrap;
              }
            }
          }
        }
      }
      .manual-subquestion {
        color: #333;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 20px;
        & > li {
          margin-bottom: 10px;
          & > span {
            float: left;
            padding-right: 7px;
          }
          .manual-subquestion-title {
            margin-bottom: 10px;
          }
          & > .manual-subquestion-options {
            overflow: hidden;
            margin: 10px 0;
            & > div {
              float: left;
              position: relative;
              padding: 0 20px;
              position: relative;
              vertical-align: top;
              font-size: 14px;
              box-sizing: border-box;
              line-height: 26px;
              & > span:nth-child(1) {
                position: absolute;
                left: 0;
                top: 0;
              }
            }
          }
          .manual-subquestion-answer {
            overflow: hidden;
            line-height: 24px;
            .manual-subquestion-answer-left {
              float: left;
              height: 24px;
              line-height: 24px;
              border-radius: 2px;
              color: #2b99ff;
              text-align: center;
              font-size: 14px;
              margin-left: -7px;
            }
            .manual-subquestion-answer-right {
              margin-left: 60px;
              color: #333;
              & > img {
                width: 100%;
              }
            }
          }
        }
      }
    }
    .manual-analyize-wrap {
      .manual-analyize {
        margin: 0 20px;
        padding-top: 20px;
        overflow: hidden;
        border-top: 1px dashed #ccc;
        .manual-analyize-item {
          padding-bottom: 20px;
          line-height: 24px;
          color: #333;
          font-size: 14px;
          .manual-analyize-left {
            float: left;
            height: 24px;
            line-height: 24px;
            border-radius: 2px;
            color: #2b99ff;
            text-align: center;
            font-size: 14px;
            margin-left: -7px;
          }
          .manual-analyize-right {
            margin-left: 60px;
            color: #333;
            & > img {
              width: 100%;
            }
          }
          .manual-no-analyize {
            & > p {
              padding-left: 60px;
              color: #ff6600;
              & > i {
                padding-right: 10px;
              }
            }
          }
        }
      }
    }
    .manual-analyize-noLogin {
      width: 100%;
      padding: 20px;
      font-size: 14px;
      box-sizing: border-box;
      color: #ff6600;
      & > span > i {
        padding-right: 8px;
      }
      & > span > a {
        color: #2b99ff;
        padding-left: 5px;
      }
    }
    .manual-message {
      position: relative;
      float: left;
      width: 100%;
      background-color: #fff;
      box-sizing: border-box;
      font-size: 12px;
      padding: 0 20px;
      color: #999;
      border-top: 1px solid #f2f2f2;
      .manual-message-layer {
        position: absolute;
        left: 0;
        top: -51px;
        z-index: 999;
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: linear-gradient(180deg, rgba(255, 255, 255, 0.46) 0%, rgba(255, 255, 255, 1) 100%);
        padding-top: 50px;
        margin-top: -50px;
        & > span {
          color: #2b99ff;
          cursor: pointer;
          & > i {
            padding-left: 5px;
            font-size: 14px;
          }
        }
      }
      .manual-message-attr {
        display: flex;
        align-items: center;
        float: left;
        & > span {
          color: #666;
          & > em {
            color: #2b99ff;
          }
        }
        & > span:nth-child(1) {
          display: inline-block;
          padding: 2px 5px;
          height: 18px;
          line-height: 18px;
          color: #2b99ff;
          border: 1px solid #2b99ff;
          text-align: center;
        }
        & > .manual-message-span1 {
          display: inline-block;
          padding: 2px 5px;
          height: 14px;
          line-height: 14px;
          color: #2b99ff;
          border: 1px solid #2b99ff;
          text-align: center;
          max-width: 80px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .source {
          & > span {
            vertical-align: middle;
          }
        }
        .manual-message-span2 {
          display: inline-block;
          width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          vertical-align: text-bottom;
          color: #999;
          &:hover {
            color: #2b99ff;
          }
        }
        & > em {
          margin: 0 14px;
          line-height: 50px;
          color: #ddd;
          font-style: normal;
        }
      }
      .manual-message-handle {
        float: right;
        & > a {
          float: left;
          margin-top: 10px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          color: #2b99ff;
          margin-right: 20px;
          &:hover {
            color: #067ff3;
          }
          & > i {
            padding-right: 5px;
          }
          &.manual-message-btn {
            display: flex;
            align-items: center;
            padding: 0 10px;
            height: 30px;
            font-size: 12px;
            border-radius: 2px;
            margin-right: 0;
            i {
              font-size: 14px;
              padding-right: 3px;
            }
          }
          &.manual-message-add {
            &:hover {
              background-color: #067ff3;
            }
            background-color: #2b99ff;
            color: #fff;
          }
          &.manual-message-remove {
            color: #808080;
            background-color: #eee;
          }
        }
      }
    }
  }
}
.shopping-cart-overNum-dialog {
  .dialog-body {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    img {
      width: 46px;
    }
    h5 {
      color: #333333;
      font-size: 16px;
      font-weight: bold;
      margin: 10px 0;
    }
    p {
      width: 260px;
      color: #999;
      line-height: 18px;
    }
  }
}
</style>

<style>
.manual-no-analyize .jumpUrl {
  color: #2b99ff;
}
</style>
